import SubscribeForm from '../../form-components/subscribe-form';

class SubscribeForm1 extends SubscribeForm {
  constructor(props) {
    super(props);
  }
}

export default SubscribeForm1;
